import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appPath } from '../routes/paths';

const BrandMark: React.FC = () => (
  <svg
    className="cp-sidebar-brand-mark"
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    focusable="false"
  >
    <path
      className="cp-sidebar-brand-mark-range"
      d="M2 28 14 12 22 20 30 8 46 28Z"
    />
    <path
      className="cp-sidebar-brand-mark-peak"
      d="M8 28 20 10 28 18 36 4 42 28Z"
    />
  </svg>
);

const SidebarBrand: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="cp-sidebar-brand"
      aria-label="Crowpeaks – go to dashboard"
      onClick={() => navigate(appPath())}
    >
      <div className="cp-sidebar-brand-lockup">
        <BrandMark />
        {!collapsed && (
          <span className="cp-sidebar-brand-wordmark">
            <span className="cp-sidebar-brand-crow">Crow</span>
            <span className="cp-sidebar-brand-peaks">peaks</span>
          </span>
        )}
      </div>
    </button>
  );
};

export default SidebarBrand;
